var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { PlatformStateRouter } from '@fxp/staterouter';
var RenderEngine = /** @class */ (function () {
    function RenderEngine(props, platformStateRouter) {
        this.props = props;
        if (platformStateRouter !== undefined && platformStateRouter !== null) {
            this._platformStateRouter = platformStateRouter;
        }
        else {
            this._platformStateRouter = PlatformStateRouter.Get();
        }
    }
    RenderEngine.prototype.Render = function (props) {
        if (props === void 0) { props = null; }
        if (props !== undefined && props !== null) {
            this.props = props;
        }
        var routeContext = this.props.RouteContext !== undefined && this.props.RouteContext !== null
            ? this.props.RouteContext
            : this.GetStateFromPlatform();
        if (routeContext === undefined || routeContext === null || routeContext.length <= 0) {
            return {
                Component: null,
                ComponentProps: null
            };
        }
        var currentState = routeContext[0];
        var nextRouteContext = __spreadArrays(routeContext.slice(1));
        if (currentState.ComponentFramework !== "React") {
            throw new Error(RenderEngine.ERROR_NON_REACT_COMPONENT);
        }
        var routedComponent = this.GetRoutedComponent(currentState, this.props);
        if (routedComponent === undefined || routedComponent === null) {
            throw new Error(RenderEngine.ERROR_UNDEFINED_COMPONENT);
        }
        var routedComponentProps = {
            RouteContext: nextRouteContext,
            Params: currentState.Params,
            Name: null
        };
        return {
            Component: routedComponent,
            ComponentProps: routedComponentProps
        };
    };
    RenderEngine.prototype.IsStoreConnected = function (context) {
        return context !== undefined
            && context !== null
            && context.store !== undefined
            && context.store !== null;
    };
    RenderEngine.prototype.GetRoutedComponent = function (currentState, props) {
        if (props.Name !== undefined && props.Name !== null && currentState.Views !== undefined && currentState.Views !== null) {
            var namedRoutedComponent = currentState.Views[props.Name];
            if (namedRoutedComponent !== undefined && namedRoutedComponent !== null) {
                return namedRoutedComponent;
            }
        }
        return currentState.Component;
    };
    RenderEngine.prototype.GetStateFromPlatform = function () {
        var currentState = this._platformStateRouter.GetCurrentRoute();
        if (currentState === undefined || currentState === null)
            return null;
        return currentState.State;
    };
    RenderEngine.ERROR_NON_REACT_COMPONENT = "ERROR: Only React components can be loaded using React UI View";
    RenderEngine.ERROR_UNDEFINED_COMPONENT = "ERROR: The react component is not defined";
    return RenderEngine;
}());
export { RenderEngine };
//# sourceMappingURL=render.engine.js.map